export var muiDialog = function muiDialog(modal) {
  return {
    open: modal.isOpen,
    onClose: function onClose() {
      return modal.close();
    },
    TransitionProps: {
      onExited: function onExited() {
        modal.resolve(null);
        modal.remove();
      }
    }
  };
};